module.exports = __webpack_public_path__ + "static/media/contentCategoryIcon.e06d84a6.svg";